module.exports = __webpack_public_path__ + "static/media/modbus-part-serial.d5473051.jpg";